import { render, staticRenderFns } from "./ClassroomTree.vue?vue&type=template&id=111a4c48&scoped=true&"
import script from "./ClassroomTree.vue?vue&type=script&lang=js&"
export * from "./ClassroomTree.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomTree.vue?vue&type=style&index=0&id=111a4c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111a4c48",
  null
  
)

export default component.exports